import React from "react";

/**
 * Hero section component for PHCG
 * 
 * @param {Object} props - Component props
 * @param {Object} props.config - Configuration object with styling parameters
 * @returns {React.Component} - The Hero section component
 */
const HeroSection = ({ config = {} }) => {
  const {
    backgroundImageUrl = "/hero_bg.png",
    overlayColor = "rgba(28, 67, 106, 0.7)",
    textColor = "#ffffff",
    headingFont = "serif",
    taglineText = "...never operate a partnership without one",
    logoUrl = "/phcg_logo.png",
    companyAcronym = "PHCG"
  } = config;

  // Detect font type for compensation
  const getFontType = (font) => {
    const fontLower = font.toLowerCase();
    if (fontLower.includes("arial") || fontLower.includes("helvetica") || fontLower.includes("sans-serif")) {
      return "sans-serif";
    } else if (fontLower.includes("courier") || fontLower.includes("monaco") || fontLower.includes("monospace")) {
      return "monospace";
    }
    return "serif";
  };

  const fontType = getFontType(headingFont);
  const fontScale = fontType === "sans-serif" ? 0.9 : fontType === "monospace" ? 0.8 : 1;
  const isWideFont = headingFont.toLowerCase().includes("georgia");
  const maxWidth = isWideFont ? "min(700px, 50vw)" : fontType === "serif" ? "min(750px, 55vw)" : "min(800px, 60vw)";

  return (
    <div
      data-font={fontType}
      style={{
        position: "relative",
        width: "100%",
        height: "70vh",
        minHeight: "500px",
        backgroundImage: `url(${backgroundImageUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: textColor,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
      }}
    >

      {/* Header bar - PHCG acronym text hidden
          IMPORTANT: Do not re-add - Hero block doesn't display company acronym */}
      {/* <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          padding: "2rem 3rem",
          zIndex: 3
        }}
      >
        <div
          style={{
            fontSize: "2rem",
            fontWeight: "bold",
            fontFamily: headingFont,
            letterSpacing: "1px"
          }}
        >
          {companyAcronym}
        </div>
      </div> */}

      {/* Main content - left aligned */}
      <div
        style={{
          width: "100%",
          maxWidth: maxWidth,
          margin: "0 auto",
          padding: "0 clamp(1rem, 6vw, 2rem)",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start", // Left align
          justifyContent: "center",
        }}
      >
        {/* Logo - hidden
            IMPORTANT: Do not re-add - Hero block doesn't display logo */}
        {/* <div
          style={{
            width: "80px",
            height: "80px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "2rem",
          }}
        >
          <img
            src={logoUrl}
            alt="PHCG Logo"
            style={{
              width: "100%",
              height: "auto",
            }}
          />
        </div> */}

        {/* Headings - left aligned */}
        <h1
          style={{
            fontFamily: headingFont,
            fontSize: isWideFont ? "clamp(2rem, 3.8vw, 3rem)" : fontType === "sans-serif" ? "clamp(2.2rem, 4.5vw, 3.15rem)" : fontType === "monospace" ? "clamp(2rem, 4vw, 2.8rem)" : fontType === "serif" ? "clamp(2.2rem, 4.2vw, 3.2rem)" : "clamp(2.5rem, 5vw, 3.5rem)",
            fontWeight: "normal",
            margin: "0 0 0.5rem",
            lineHeight: 1.1,
            textAlign: "left",
            overflowWrap: "break-word",
            wordBreak: "break-word",
            hyphens: "auto",
            maxWidth: "100%"
          }}
        >
          A Partnership Charter™
        </h1>
        
        <h2
          style={{
            fontFamily: headingFont,
            fontSize: isWideFont ? "clamp(1.6rem, 3.2vw, 2.3rem)" : fontType === "sans-serif" ? "clamp(1.8rem, 3.6vw, 2.52rem)" : fontType === "monospace" ? "clamp(1.6rem, 3.2vw, 2.24rem)" : fontType === "serif" ? "clamp(1.8rem, 3.5vw, 2.5rem)" : "clamp(2rem, 4vw, 2.8rem)",
            fontWeight: "normal",
            margin: 0,
            lineHeight: 1.1,
            textAlign: "left",
            overflowWrap: "break-word",
            wordBreak: "break-word",
            hyphens: "auto",
            maxWidth: "100%" 
          }}
        >
          {taglineText}
        </h2>
      </div>
    </div>
  );
};

export default HeroSection;